import axios from '../axios';
import { fireAnalytics } from '../utils/firebase';
import { getSessionId, getDeviceCategory } from '../utils/analyticsHelpers.ts';

export interface LLMAnalysisResult {
  actionId: string | null;
  confidence: number;
  response: string;
  guideMode?: boolean;
  needsData?: boolean;
  data?: any;
  total?: number;
  noResultsMessage?: string;
  quotationType?: string;
  workVisibility?: string;
  isPublic?: boolean;
}

export interface ConversationMessage {
  role: 'user' | 'assistant';
  content: string;
  actionId?: string | null;
}

const getAuthHeaders = () => {
  const authToken = localStorage.getItem("access-Token-Edify");
  return { headers: { Authorization: `Bearer ${authToken}` } };
};

const getUserId = (): string => {
  try {
    const state = JSON.parse(localStorage.getItem('persist:general') || '{}');
    const generalState = JSON.parse(state.general || '{}');
    return generalState.userData?.id || '';
  } catch (e) {
    return '';
  }
};

export const analyzeWithLLM = async (
  query: string, 
  history?: ConversationMessage[]
): Promise<LLMAnalysisResult> => {
  try {
    const response = await axios.post<{ 
      message: string; 
      data: LLMAnalysisResult;
    }>(
      '/chatbot/message',
      { 
        message: query,
        history: history || []
      },
      getAuthHeaders()
    );
    
    const responseData = response.data.data;
    
    if (!responseData) {
      throw new Error('Respuesta del servidor en formato inesperado');
    }
    
    const userId = getUserId();
    fireAnalytics("agent_message_sent", {
      edify_user_id: userId,
      session_id: getSessionId(),
      device_category: getDeviceCategory(),
      category: "agent",
      action: "message_sent",
      query_length: query.length,
      action_id: responseData.actionId || null,
      confidence: responseData.confidence || null,
      guide_mode: responseData.guideMode || false,
      has_data: !!responseData.data,
      needs_data: responseData.needsData || false,
      history_length: history?.length || 0
    });
    
    return responseData;
  } catch (error) {
    const userId = getUserId();
    fireAnalytics("agent_message_error", {
      edify_user_id: userId,
      session_id: getSessionId(),
      device_category: getDeviceCategory(),
      category: "agent",
      action: "message_error",
      query_length: query.length,
      history_length: history?.length || 0,
      error_type: error instanceof Error ? error.message : "unknown_error"
    });
    
    throw new Error('Error conectando con el servicio de análisis');
  }
};

